export default __webpack_public_path__ + "static/media/signal_piano.0208aeed.mp3";